import VenueCardGrid from './VenueCardGrid';

export default VenueCardGrid;
